import React from 'react'

export const Report = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d="M9 15V14H10V15H9Z"/>
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M18 2C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H18ZM10.5 12H8.5C7.67157 12 7 12.6716 7 13.5V15.5C7 16.3284 7.67157 17 8.5 17H10.5C11.3284 17 12 16.3284 12 15.5V13.5C12 12.6716 11.3284 12 10.5 12ZM15.9999 13.5H13.9999C13.4477 13.5 12.9999 13.9477 12.9999 14.5C12.9999 15.0128 13.386 15.4355 13.8833 15.4933L13.9999 15.5H15.9999C16.5522 15.5 16.9999 15.0523 16.9999 14.5C16.9999 13.9872 16.6139 13.5645 16.1165 13.5067L15.9999 13.5ZM10.1339 6.76261L8.71963 8.17682L8.36607 7.82326C7.97555 7.43273 7.34238 7.43273 6.95186 7.82326C6.56134 8.21378 6.56134 8.84695 6.95186 9.23747L7.83574 10.1214C8.3239 10.6095 9.11535 10.6095 9.6035 10.1214L11.5481 8.17684C11.9386 7.78632 11.9386 7.15316 11.5481 6.76263C11.1576 6.3721 10.5244 6.37209 10.1339 6.76261ZM15.9999 8.00012H13.9999C13.4477 8.00012 12.9999 8.44784 12.9999 9.00012C12.9999 9.51296 13.386 9.93561 13.8833 9.99337L13.9999 10.0001H15.9999C16.5522 10.0001 16.9999 9.55241 16.9999 9.00012C16.9999 8.48729 16.6139 8.06461 16.1165 8.00685L15.9999 8.00012Z"
    />
  </svg>
)
